import React, { Component } from 'react'
import Label from './Label'

let id = 0

export default class Checkbox extends Component {
  constructor (...props) {
    super(...props)
    this.id = id++
  }
  render () {
    let { checked, label, onChange, title } = this.props
    return (
      <div>
        <input type='checkbox'
          className='ncss-checkbox'
          id={`ncss-checkbox-${this.id}`}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)} />
        <Label className='pl6-sm' htmlFor={`ncss-checkbox-${this.id}`} title={title}>
          {label}
        </Label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/src/components/ncss/Checkbox.js